import * as React from "react";
import { View as DefaultView } from "react-native";
import useThemeColor from "../../hooks/useThemeColor";

type ThemeProps = {
  lightColor?: string;
  darkColor?: string;
  transparent?: boolean;
};

export type ViewProps = ThemeProps & DefaultView["props"];

export default function View(props: ViewProps) {
  const {
    style,
    lightColor,
    darkColor,
    transparent = false,
    ...otherProps
  } = props;
  const backgroundColor = transparent
    ? "transparent"
    : useThemeColor({ light: lightColor || 'transparent', dark: darkColor || 'transparent' }, "background");

  return <DefaultView style={[{ backgroundColor }, style]} {...otherProps} />;
}
